import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { CURRENT_CLIENT_TEMPLATE_VAR } from '@core';

@Injectable({
  providedIn: 'root',
})
export class DeviceActionsService {
  private http = inject(HttpClient);

  sendAction({
    actionPointId,
    deviceId,
    value = '',
  }: {
    actionPointId: string;
    deviceId: string;
    value?: string;
  }) {
    return this.http.post(
      `devices/v1/clients/${CURRENT_CLIENT_TEMPLATE_VAR}/devices/${deviceId}/execute/${actionPointId}`, { value },
    );
  }
}
